var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-container"},[(_vm.detailsComponent)?_c(_vm.detailsComponent,{tag:"component",attrs:{"application-map":_vm.applicationMap}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }